import { useEffect, useState } from "react";
import styles from "./add.module.css";
import { InputLabel, TextField } from "@mui/material";
import { useNavigate, useParams } from "react-router";
import axios from "axios";
import { useForm, Controller } from "react-hook-form";
import { authData, withAdminAuth } from "../../components/GetAuth";
import Loader from "../../components/Loader";
import { Home } from "react-feather";
import { Editor } from '@tinymce/tinymce-react';

const AddShipping = ({ history, match }) => {
  const auth = authData();
  const navigate = useNavigate();
  const { templateId } = useParams();
  const [loading, setLoading] = useState(false);

  const { register, handleSubmit, control, formState: { errors }, setValue } = useForm({
    mode: "onChange",
    defaultValues: {
      title: "",
      content: ""
    }
  });

  useEffect(() => {
    if (templateId) {
      axios.get(process.env.REACT_APP_API_URL + "v1/email-templates/" + templateId, {
        headers: {
          Authorization: `Bearer ${auth?.api_token}`,
        }
      }).then((response) => {
        if (response.data.status === "SUCCESS") {
          let templateData = response.data.data;
          setValue("title", templateData?.title);
          setValue("content", templateData?.content);
        }
      });
    }
  }, [templateId, setValue, auth?.api_token]);

  const onSubmit = (data) => {
    setLoading(true);

    if (templateId) {
      return axios.post(process.env.REACT_APP_API_URL + "v1/email-templates/" + templateId, data, {
        headers: {
          Authorization: `Bearer ${auth?.api_token}`
        }
      }).then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          navigate("/email-template/list");
        }
      }).catch((error) => {
        setLoading(false);
      });
    } else {
      return axios.post(process.env.REACT_APP_API_URL + "v1/email-templates", data, {
        headers: {
          Authorization: `Bearer ${auth?.api_token}`
        }
      }).then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          navigate("/email-template/list");
        }
      }).catch((error) => {
        setLoading(false);
      });
    }
  }

  return (<>
    {loading && <Loader />}
    <div className={`${styles.MainDiv}`}>
      <div className={`${styles.MainCard}`}>

        <div className={`${styles.PageTitleWrap}`}>
          <p className={`${styles.PageTitle}`}>{templateId ? 'Edit Email Template' : 'Add Email Template'}</p>
          <nav aria-label="breadcrumb">
            <ol className={`${styles.breadcrumb}`}>
              <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Email Templates</li>
              <li className={`${styles.breadcrumbItem} ${styles.active}`}>{templateId ? 'Edit' : 'Add'}</li>
            </ol>
          </nav>
        </div>


        <div className={`${styles.StepOneForm}`}>
          <form onSubmit={handleSubmit(onSubmit)}>

            <div>

              <div className={`FormHalfGroup`} style={{ width: '40%', marginLeft: 0 }} >
                <Controller
                  control={control}
                  {...register("title", { required: "This field is Required" })}
                  render={({ field }) => (<TextField {...field} label="Title*" variant="outlined" />)}
                />
                {errors.title && (<span className={`ErrorM`}>{errors?.title?.message}</span>)}
              </div>

              <div className={`FormHalfGroup`} style={{ width: '100%', marginLeft: 0 }}>
                <InputLabel style={{ margin: '20px 0 10px 0', color: '#000' }}>Email Content?*</InputLabel>
                <Controller
                  name="content"
                  control={control}
                  rules={{ required: 'This field is Required' }}
                  render={({ field, fieldState }) => (<div>
                    <Editor
                      apiKey={process.env.REACT_APP_TINYMCE_API_KEY}
                      value={field.value}
                      onEditorChange={(content) => field.onChange(content)}
                      init={{
                        height: 700,
                        menubar: false,
                        plugins: ["lists", "code", "table"],
                        toolbar: ["undo redo | bold italic underline strikethrough | forecolor backcolor removeformat | fontselect fontsize | alignleft aligncenter alignright alignjustify | numlist bullist | table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol | code", "compnaylogo customer_name company_name company_phone company_email company_address company_url"],
                        font_size_formats: "8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt 48pt",
                        setup: (editor) => {
                          editor.ui.registry.addButton("compnaylogo", {
                            text: "Compnay Logo",
                            onAction: () =>
                              editor.insertContent(`<img src="https://dummyimage.com/260x80/cccccc/000000&text=Company+Logo" alt="" width="260" style="max-width:260px; width:100%; height:auto; display:block; margin:0 auto; border:0;" />`),
                          });
                          editor.ui.registry.addButton("customer_name", {
                            text: "Customer Name",
                            onAction: () =>
                              editor.insertContent(`[Name of Customer]`),
                          });
                          editor.ui.registry.addButton("company_name", {
                            text: "Company Name",
                            onAction: () =>
                              editor.insertContent(`[Name of Company]`),
                          });
                          editor.ui.registry.addButton("company_phone", {
                            text: "Company Phone",
                            onAction: () =>
                              editor.insertContent(`[Company Phone]`),
                          });
                          editor.ui.registry.addButton("company_email", {
                            text: "Company Email",
                            onAction: () =>
                              editor.insertContent(`[Company Email]`),
                          });
                          editor.ui.registry.addButton("company_address", {
                            text: "Company Address",
                            onAction: () =>
                              editor.insertContent(`[Company Address]`),
                          });
                          editor.ui.registry.addButton("company_url", {
                            text: "Company URL",
                            onAction: () =>
                              editor.insertContent(`[Company URL]`),
                          });
                        }
                      }}
                    />
                  </div>)}
                />
                {errors.content && (<span className={`ErrorM`}>{errors?.content?.message}</span>)}
              </div>

            </div>

            <div className={`${styles.StepBUSec}`}>
              <button className={`${styles.Next}`} type="submit">{templateId ? 'Update' : 'Save'}</button>
              <button className={`${styles.Next3}`} type="button" onClick={(e) => navigate("/email-template/list")}>Cancel</button>
            </div>
          </form>
        </div>
      </div >
    </div>
  </>);
};

export default withAdminAuth(AddShipping);